
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/glossary/[term]",
      function () {
        return require("private-next-pages/glossary/[term].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/glossary/[term]"])
      });
    }
  